import { effect } from "../fmt";
import { Effect } from "./Effect";
import type { Ruleset, WeaponProfileData } from "./Ruleset";

export class WeaponProfile {
  ruleset: Ruleset;
  data: WeaponProfileData;

  constructor(ruleset: Ruleset, data: WeaponProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get type() {
    return this.data.type;
  }

  get traits() {
    return (
      this.data.traits?.map((ref) => this.ruleset.weaponTraits.get(ref.id)) ??
      []
    );
  }

  get effects() {
    const weaponEffects =
      this.data.effects?.map((data) => Effect.from(this.ruleset, data)) ?? [];

    const traitEffects = this.traits.flatMap((lookup) => {
      return (
        lookup
          .valueOrNull()
          ?.effects?.map((data) => Effect.from(this.ruleset, data)) ?? []
      );
    });

    return [...traitEffects, ...weaponEffects];
  }

  get summary() {
    return [
      ...this.traits.filter((l) => l.isSuccess).map((l) => `${l.value.name}.`),
      ...this.effects.map(effect),
    ].join(" ");
  }
}
